import React, { useEffect, useState } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  InputAdornment,
  TextField,
  Select,
  FormControl,
  MenuItem,
} from "@mui/material";
import ReactApexChart from "react-apexcharts";
import "./byschoolchart.scss";
import { useQuery } from "@apollo/client";

import { AuthContext } from "../../../Context/AuthContext";
import { translateLauguage } from "../../../Function/Translate";

import { GET_STUDENT_ENROLLMENT_SHOW_BY_LEVEL } from "../../../Schema/Dashboard";
import LoadingPage from "../../Include/LoadingPage";

export default function TotalEnrollmentBySchool({ academicYearId, schoolId, schoolName }) {
  // Change Language
  const { language } = React.useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [totalData, setTotalData] = useState([]);
  const [loading, setLoading] = useState(true);

  const { refetch } = useQuery(GET_STUDENT_ENROLLMENT_SHOW_BY_LEVEL, {
    variables: {
      academicYearId: academicYearId ?? null,
      schoolId: schoolId ?? null
    },
    onCompleted: ({ getStudentEnrollmentChartShowByLevel }) => {
      setTotalData(getStudentEnrollmentChartShowByLevel);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const levelData = totalData?.map((e) => {
    return t("grade") + " " + e?.levelName;
  });

  const totalStudent = totalData?.map((e) => e?.totalStudent)
  const totalFemale = totalData?.map((e) => e?.female)

  const maxSeriesData = Math.max(...(totalStudent?.length ? totalStudent : []));

  useEffect(() => {
    refetch();
  }, [academicYearId, schoolId]);


  const state = {
    options: {
      chart: {
        type: "bar",
        height: 350,
        fontFamily: "Khmer OS Siemreap",
        stacked: false,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "50%",
          endingShape: "rounded",
          dataLabels: {
            position: "top", // top, center, bottom
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -25,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
        formatter: function (val, opts) {
          if (val > 0) {
            return val;
          } else {
            return "0";
          }
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: levelData,
        // categories: ["10", "11", "12"],
      },
      yaxis: {
        // max: maxSeriesData + 5,
        labels: {
          style: {
            fontFamily: "Siemreap",
          },
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            if (val > 0) {
              return val + " នាក់";
            } else {
              return 0 + " នាក់";
            }
          },
        },
      },
      fill: {
        opacity: 1,
      },
    },
    series: [
      {
        name: t("total_student"),
        data: totalStudent,
        // data: [10, 15, 20],
        color: "#0071F1",
      },
      {
        name: t("total_female"),
        data: totalFemale,
        // data: [5, 10, 15],
        color: "#01B6CB",
      },
    ],
  };

  return (
    <Box className="total-enrollment-by-school-chart">
      <Stack direction="row" alignItems="center" justifyContent="center">
        <Typography
          className={language === "en" ? "chart-title" : "chart-title-kh"}
        >
          {t("total_enrollment_by_school")} {schoolName}
        </Typography>
      </Stack>

      {
        loading ? <LoadingPage /> :
          <div id="chart">
            <ReactApexChart
              options={state.options}
              series={state.series}
              type="bar"
              height={350}
            />
          </div>
      }
    </Box>
  );
}
